import { ActivatedRoute } from '@angular/router';
import { HeaderService } from '../../services/header.service';
import { StorageModule } from '../../utils/storage.module';

export class BasePage {
  public title: string;
  public subtitle: string;
  public titleButton?: string;

  /* Control of visibility*/
  public showHeader: boolean = true;
  public showStepper: boolean = true;

  constructor(
    public storage: StorageModule,
    public headerService: HeaderService,
    public activatedRoute: ActivatedRoute
  ) {}
}
